import customfn from "@/_functions.js";

$(function () {


    // Add new register_iq row
    $(document).on('click', '#add_iq_row', function (ev) {
        ev.preventDefault();
        customfn.cloneRow($('.iq-row:first'), 'iq');
    });

    // Register IQ
    $(document).on('click', '.register_iq', function (ev) {
        ev.preventDefault();
        // This is the tr where the button is clicked
        var $selectedTr = $(this).closest('tr');
        // Build the url and formfields
        var url = '/centre/register_iq';

        customfn.registerItem($selectedTr, url, 'iq', $(this));
    });

    // When there is clicked on the next button, first do some checks before the user is redirected
    // to the next step.
    $(document).on('submit', '#centre_register_iqs', function (ev) {
        return customfn.postRegisterItems($(this), 'iqs', 'iq');
    });


    // Add new register_repeater row
    $(document).on('click', '#add_repeater_row', function (ev) {
        ev.preventDefault();
        customfn.cloneRow($('.repeater-row:first'), 'repeater');
    });

    // Register Repeater
    $(document).on('click', '.register_repeater', function (ev) {
        ev.preventDefault();
        // This is the tr where the button is clicked
        // Build the url and formfields
        var url = '/centre/register_repeater';

        var $selectedTr = $(this).closest('tr');

        return customfn.registerItem($selectedTr, url, 'repeater', $(this));
    });

    // When there is clicked on the next button, first do some checks before the user is erdirected
    // to the next step.
    $(document).on('submit', '#centre_register_repeaters', function (ev) {
        return customfn.postRegisterItems($(this), 'repeaters', 'repeater');
    });

    // When a user clicks on the add nontitan button, let's add a new row for the user
    $(document).on('click', '#add_non_titan_row', function (ev) {
        ev.preventDefault();
        customfn.cloneRow($('.nontitan-centre-space-row:first'), 'non_titan');
    });

    $(document).on('change', 'input[type=checkbox][name="standalone[]"]', function (event) {
        let row = $(event.target).closest('tr');
        let cloneDivIndex = $(this).parent('div').parent('div.clonediv').index();

        if ($(this).is(':checked')) {
            row.find('select[name="lock_attach_to[]"]').eq(cloneDivIndex).attr('disabled', true).prop('disabled', true);
        } else {
            row.find('select[name="lock_attach_to[]"]').eq(cloneDivIndex).attr('disabled', false).prop('disabled', false);
        }
    });

    /**
     * Connect locks to centre spaces -- Start
     */
    let count = 1;

    $(document).on('click', '.extra_lock.add-mac-address', function (ev) {
        ev.preventDefault();
        // Rist add the mac address and a name
        var $ownTd = $(this).closest('td');
        var $clonedTr = $ownTd.find('.clonediv:first').clone();

        // unique id for standalone checkbox so clicking on label works correctly
        let uniqueId = parseInt($clonedTr.data('random-number')) + count++;
        let standaloneCheckboxId = 'standalone_checkbox_' + $clonedTr.data('inventory-id') + '_' + uniqueId;

        // set all values, readonly etc to the default start
        $clonedTr.find('input[type=checkbox][name="standalone[]"]').val('').attr('disabled', false).prop('disabled', false);
        $clonedTr.find('input[type=checkbox][name="standalone[]"]').val('').attr('checked', false).prop('checked', false);
        $clonedTr.find('input[type=checkbox][name="standalone[]"]').attr('id', standaloneCheckboxId);
        $clonedTr.find('input[type=checkbox][name="standalone[]"]').next('label').attr('for', standaloneCheckboxId);
        let wallReaderCheckboxId = 'wall_reader-' + $clonedTr.data('inventory-id') + '_' + uniqueId;
        $clonedTr.find('input[name="wall_reader[]"]').val('').attr('disabled', false).prop('disabled', false).removeClass('d-none');
        $clonedTr.find('input[name="wall_reader[]"]').next('label').removeClass('d-none');
        $clonedTr.find('input[name="wall_reader[]"]').attr('id', wallReaderCheckboxId);
        $clonedTr.find('input[name="wall_reader[]"]').next('label').attr('for', wallReaderCheckboxId);
        $clonedTr.data('lock-id', '');
        $clonedTr.removeAttr('data-lock-id');
        $clonedTr.find('input').val('').attr('readonly', false).prop('readonly', false);
        $clonedTr.find('select').val('0').attr('disabled', false).prop('disabled', false);
        $clonedTr.find('.detach-lock').hide();
        // remove error styling from cloned mac and name input
        $clonedTr.find('.form-group').find('input').removeClass('is-invalid');
        // remove error styling from attach to select
        let $nextTd = $(this).closest('td').next().find('.clonediv:first');
        $nextTd.find('.form-group').find('select').removeClass('is-invalid');
        $clonedTr.find('.form-group p.invalid-feedback').html('').hide();
        $clonedTr.find('.form-group .spinner').hide();
        $clonedTr.find('.form-group .btn').show();
        $clonedTr.find('.form-group').show().addClass('both-visible');
        $clonedTr.find('td.lock-macs').addClass('both-visible');
        $clonedTr.find('.locks-errors').hide();

        // Add the fields
        // Add the cloned Tr to the table
        $ownTd.find('.clonediv:first').parent().append($clonedTr);

        $clonedTr.find('input:first').click().focus();

        // First remove the button so we dont make a copy
        $clonedTr.find('.extra_lock.add-mac-address').remove();
        $(this).detach().appendTo($clonedTr);

        // And add a device list for this lock
        var $clonedButtonTr = $(this).closest('td').next().find('.clonediv:first').clone();

        // set all values, readonly etc to the default start
        $clonedButtonTr.data('lock-id', '');
        $clonedButtonTr.removeAttr('data-lock-id');
        $clonedButtonTr.find('input').val('').attr('readonly', false).prop('readonly', false);
        $clonedButtonTr.find('select').val('0').attr('disabled', false).prop('disabled', false);
        $clonedButtonTr.find('.detach-lock').hide();
        $clonedButtonTr.find('.form-group').removeClass('is-invalid');
        $clonedButtonTr.find('.form-group p.invalid-feedback').html('').hide();
        $clonedButtonTr.find('.form-group .spinner').hide();
        $clonedButtonTr.find('.form-group .btn').show();

        // Add it
        $clonedButtonTr.insertAfter($(this).closest('td').next().find('.clonediv:last'));

        // Show name fields for all rows
        $ownTd.find('.form-group').show().addClass('both-visible');
        $ownTd.addClass('both-visible');
        // always hide error message when showing name field
        $ownTd.find('.form-group > .form-group p.invalid-feedback').html('').hide();

        // Also add a new button to check
        var $clonedButtonTr = $(this).closest('td').next().next().find('.clonediv:first').clone();
        $clonedButtonTr.find('.invalid-feedback').remove();
        $clonedButtonTr.find('.check-icon').remove();
        $clonedButtonTr.find('.spinner').hide();
        $clonedButtonTr.find('.btn').each(function() {
            customfn.resetButtonLoadingState(this);
        });
        $clonedButtonTr.find('.btn').show();


        // Add it
        $clonedButtonTr.insertAfter($(this).closest('td').next().next().find('.clonediv:last'));

    });

    /**
     * Unlock mac address
     */

    $(document).on('click', '.detach-lock', function(ev){
        ev.preventDefault();
        var btn = $(this),
            url = btn.attr('href'),
            icon = $('<span></span>');

        icon.addClass('spinner visible anim-spin detach-lock-spinner');
        btn.before(icon);
        btn.hide();

        customfn.getModal(url, undefined, {keyboard: false, backdrop: 'static'}, function(){
            btn.show();
            btn.parent().find('.detach-lock-spinner').remove();
        });
    });

    $(document).on('click', '.space-removed', function(ev){
        ev.preventDefault();
        var inventory_id = $(this).data('inventory-id');
        var row = $('#centre-centre-inventory-item-'+inventory_id);
        var rows = $('.nontitan-centre-space-row');
        if (rows.length <= 1) {
            $('#add_non_titan_row').trigger('click');
        }
        row.remove();
    });

    // Register a lock for titan inventory
    $(document).on('click', '.register_lock_titan', function (ev) {
        ev.preventDefault();
        var returnValue = true;
        var self = this;
        var $selectedTd = $(this).closest('td');
        // Get the index to grab the values
        var rowIndex = $(this).closest('.clonediv').index();

        // Get the formfields and add the csrf-token
        var formFields = [];
        //inventoryId
        formFields.push({
            name: "inventory_id",
            value: $selectedTd.closest('tr').find('input[name=inventory_id]').val()
        });
        // Location
        formFields.push({
            name: "inventory_location",
            value: $selectedTd.closest('tr').find('input[name=inventory_location]').val()
        });
        // Standalone
        formFields.push({
            name: "standalone",
            value: $selectedTd.closest('tr').find('input[name="standalone[]"]:eq(' + rowIndex + ')').is(':checked')
        });
        formFields.push({
            name: "wall_reader",
            value: $selectedTd.closest('tr').find('input[name="wall_reader[]"]:eq(' + rowIndex + ')').is(':checked')
        });
        // lock data
        formFields.push({
            name: "lock_mac_address",
            value: $selectedTd.prev().prev().find('input[name="lock_mac_address[]"]:eq(' + rowIndex + ')').val()
        });
        formFields.push({
            name: "lock_attach_to",
            value: $selectedTd.prev().find('select[name="lock_attach_to[]"]:eq(' + rowIndex + ')').val()
        });
        formFields.push({
            name: "clp_lock_id",
            value: $selectedTd.prev().find('input[name="clp_lock_id[]"]:eq(' + rowIndex + ')').val()
        });
        formFields.push({
            name: "_token",
            value: $(document).find('input[name="_token"]').val()
        });

        if($selectedTd.closest('tr').find('.lock-macs').hasClass('both-visible')) {
            formFields.push({
                name: "multiple",
                value: true
            });
        }

        var button = $(document).find('button[data-loading-text]');
        var thisButton = $(this);


        // Remove the is-invalid class and invalid-feedback texts
        customfn.unsetErrorsClasses($selectedTd, 'titan');

        // Set the input to readonly
        customfn.doReadOnlyLocks($selectedTd, rowIndex, true, 'titan');

        // And set the next button to loading
        customfn.setButtonLoadingState(button);
        customfn.setButtonLoadingState(thisButton);

        var url = '/centre/register_lock';

        $.post(url, $.param(formFields), function (data) {
            })
            .fail(function (jqxhr) {
                var data = jqxhr.responseJSON;
                customfn.setErrors(data, $selectedTd, rowIndex, 'titan');
                $selectedTd.closest('tr').find('button.detach-lock').hide();
                customfn.resetButtonLoadingState(button);
                customfn.resetButtonLoadingState(thisButton);
            })
            .done(function (data) {
                customfn.afterRegistration($selectedTd, data, rowIndex, 'titan');
                $selectedTd.closest('tr').find('.clonediv:eq(' + rowIndex + ')').find('button.detach-lock').show();
                customfn.resetButtonLoadingState(button);
                customfn.resetButtonLoadingState(thisButton);
                var invRow = $selectedTd.closest('tr');
                invRow.find('.multiple_rooms').removeClass('disabled').prop('disabled', false).removeAttr('disabled');

                if (typeof data.clusteredWith != 'undefined' && data.clusteredWith != '') {
                    if (invRow.next().hasClass('clustered-with-row')) {
                        invRow.next().find('td').find('span').text(data.clusteredWith);
                        invRow.next().show();
                    }
                } else {
                    if (invRow.next().hasClass('clustered-with-row')) {
                        invRow.next().hide();
                    }
                }

                // reload here so page updates in case we have multiple locks for an inventory
                // this matters because we use clone.index() to delete the correct lock when there are multiple
                if (invRow.find('td.lock-macs .clonediv').length > 1) {
                    location.reload();
                }
            });

    });

    $(document).on('click', '.unregister_lock_nontitan', function (ev) {
        ev.preventDefault();
        var btn = $(this),
            url = btn.attr('href'),
            icon = $('<span></span>');


        if (url === "") {
            var row = btn.closest('tr');
            var rows = $('.nontitan-centre-space-row');
            if (rows.length <= 1) {
                $('#add_non_titan_row').trigger('click');
            }
            row.remove();
        } else {
            icon.addClass('spinner visible anim-spin unregister_lock_nontitan-spinner');
            btn.before(icon);
            btn.hide();

            customfn.getModal(url, undefined, {keyboard: false, backdrop: 'static'}, function () {
                btn.show();
                btn.parent().find('.unregister_lock_nontitan-spinner').remove();
            });
        }
    });

    $(document).on('click', '.register_lock_nontitan', function (ev) {
        ev.preventDefault();
        var $selectedTd = $(this).closest('td');
        // Get the index to grab the values
        var rowIndex = $(this).closest('.clonediv').index();

        // Get the formfields and add the csrf-token
        var formFields = [];
        //inventoryId
        formFields.push({
            name: "inventory_id",
            value: $selectedTd.closest('tr').find('input[name=inventory_id]').val()
        });
        formFields.push({
            name: "inventory_type",
            value: $selectedTd.closest('tr').find('select[name=inventory_type]').val()
        });
        formFields.push({
            name: "inventory_name",
            value: $selectedTd.closest('tr').find('input[name=inventory_name]').val()
        });
        // Location
        formFields.push({
            name: "inventory_location",
            value: $selectedTd.closest('tr').find('input[name=inventory_location]').val()
        });
        // Standalone
        formFields.push({
            name: "standalone",
            value: $selectedTd.closest('tr').find('input[name="standalone[]"]:eq(' + rowIndex + ')').is(':checked')
        });
        formFields.push({
            name: "wall_reader",
            value: $selectedTd.closest('tr').find('input[name="wall_reader[]"]:eq(' + rowIndex + ')').is(':checked')
        });
        // lock data
        formFields.push({
            name: "lock_mac_address",
            value: $selectedTd.prev().prev().find('input[name="lock_mac_address[]"]:eq(' + rowIndex + ')').val()
        });
        formFields.push({
            name: "lock_attach_to",
            value: $selectedTd.prev().find('select[name="lock_attach_to[]"]:eq(' + rowIndex + ')').val()
        });
        formFields.push({
            name: "clp_lock_id",
            value: $selectedTd.prev().find('input[name="clp_lock_id[]"]:eq(' + rowIndex + ')').val()
        });
        formFields.push({
            name: "_token",
            value: $(document).find('input[name="_token"]').val()
        });

        if($selectedTd.closest('tr').find('.lock-macs').hasClass('both-visible')) {
            formFields.push({
                name: "multiple",
                value: true
            });
        }

        var button = $(document).find('button[data-loading-text]');
        var thisButton = $(this);
        const invRow = $selectedTd.closest('tr');

        if (invRow.find('input[name=inventory_location]').val() != '' ||
            invRow.prev().find('select[name="lock_attach_to[]"]:eq(' + rowIndex + ')').val() != '0' ||
            invRow.find('input[name=inventory_location]').val()
        ) {

            // Remove the is-valid class and error texts
            customfn.unsetErrorsClasses($selectedTd, 'nontitan');

            // Set the input to readonly
            customfn.doReadOnlyLocks($selectedTd, rowIndex, true, 'nontitan');

            // And set the next button to loading
            var button = $(document).find('button[data-loading-text]');
            customfn.setButtonLoadingState(button);
            var thisButton = $(this);
            customfn.setButtonLoadingState(thisButton);

            var url = '/centre/register_lock_nontitan';

            $.post(url, $.param(formFields), function (data) {
                    // Onsuccess
                })
                .fail(function (jqxhr) {
                    let data = jqxhr.responseJSON || {errors: {main_error: 'The request failed. Please try again.'}};
                    customfn.setErrors(data, $selectedTd, rowIndex, 'nontitan');
                    customfn.resetButtonLoadingState(button);
                    customfn.resetButtonLoadingState(thisButton);
                })
                .done(function (data) {
                    customfn.afterRegistration($selectedTd, data, rowIndex, 'nontitan');
                    customfn.resetButtonLoadingState(button);
                    customfn.resetButtonLoadingState(thisButton);

                    // reload here (if no errors) so page updates in case we have multiple locks for an inventory
                    // this matters because we use clone.index() to delete the correct lock when there are multiple
                    if (invRow.find('td.lock-macs .clonediv').length > 1 && invRow.find('p.help-block').length === 0) {
                        location.reload();
                    }
                });
        } else {
            // Add error to row
            var err = $('.fields_required_error').val(),
                invalid_feedback = $selectedTd.prev().find('.clonediv:eq(' + rowIndex + ')').find('select').closest('div.form-group').find('p.invalid-feedback');

            if(invalid_feedback.parent().hasClass('e-wrap')) {
                invalid_feedback.unwrap('.e-wrap');
            }
            invalid_feedback.wrap('<div class="e-wrap"></div>').text(err).show();

            setTimeout(function(){
                customfn.resetButtonLoadingState(button);
                customfn.resetButtonLoadingState(thisButton);
            }, 800);
        }
    })

    // If there is a name typed in the text field and the lockname is not visible and empty

    /**
     * Connect locks to centre spaces -- End
     */

    /**
     * Start - Commissioning flow multiple spaces to a lock
     */
    $(document).on('click', '.multiple_rooms', function(ev){
        ev.preventDefault();
        var button = $(this);
        var url = $(this).attr('href');
        button.attr('disabled', 'disabled').prop('disabled', true);
        button.find('.fa.fa-share-alt').hide();
        button.find('.fa.fa-cog').remove();
        button.find('.fa.fa-share-alt').after('<span class="fa fa-cog fa-spin"></span>');

        customfn.getModal(url, undefined, {keyboard: false, backdrop: 'static'}, function(){
            button.find('.fa.fa-share-alt').show();
            button.find('.fa.fa-cog').remove();
            button.removeAttr('disabled').prop('disabled', false);
        });
    });

    $(document).on('click', '.save_multiple_inventory', function(ev){
        ev.preventDefault();
        var button = $(this);
        var url = $(this).attr('href');
        customfn.setButtonLoadingState(button);

        var formFields = $(document).find('form#multiple_spaces_select').serialize();
        customfn.postModal(url, formFields, undefined, function(data){
            if(data.show){
                // Loop over the items and show the row
                // And remove, if needed, the grey row
                $.each(data.show, function( index, value ) {
                    var row = $(document).find('#centre-centre-inventory-item-'+value.centre_inventory_id);
                    row.show();

                    if(row.next().hasClass('clustered-with-row')){
                        row.next().hide();
                    }
                });
            }
            if(data.hide){
                // Loop over the items and hide this rows
                // And remove, if needed, the grey row

                $.each(data.hide, function( index, value ) {
                    var row = $(document).find('#centre-centre-inventory-item-'+value.centre_inventory_id);
                    row.hide();

                    if(row.next().hasClass('clustered-with-row')){
                        row.next().hide();
                    }
                });
            }

            var invRow = $(document).find('#centre-centre-inventory-item-'+data.inventory);
            if(typeof data.clusteredWith != 'undefined' && data.clusteredWith != ''){
                if(invRow.next().hasClass('clustered-with-row')){
                    invRow.next().find('td').find('span').text(data.clusteredWith);
                    invRow.next().show();
                }
                invRow.find('.multiple_rooms').addClass('active');
            }
            else{
                invRow.find('.multiple_rooms').removeClass('active');
                if(invRow.next().hasClass('clustered-with-row')){
                    invRow.next().hide();
                }
            }
        });
    });
    /**
     * End - Commissioning flow multiple spaces to a lock
     */

    // Send a user to a certain step
    $(document).on('click', '.unlinked_step_to', function(ev){
        var url = $(this).attr('href');
        var step = $(this).data('step');
        var button = $(this);
        customfn.setButtonLoadingState(button);

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "step", value: step});

        var $form = $('<form>', {
            action: url,
            method: 'post'
        });

        // Add the values
        $('<input>').attr({
            type: "hidden",
            name: '_token',
            value: $(document).find('input[name="_token"]').val()
        }).appendTo($form);
        $('<input>').attr({
            type: "hidden",
            name: 'step',
            value: step
        }).appendTo($form);

        $form.appendTo('body').submit();
    })


    $(document).on('change', '.repeater-row select', function(ev){
        var row = $(this).closest('tr');
        customfn.checkForChangeOldata(row);
    });
    $(document).on('change, keyup', '.repeater-row input[type="text"]:not(.readonly-field), .iq-row input[type="text"]:not(.readonly-field)', function(){
        var row = $(this).closest('tr');
        customfn.checkForChangeOldata(row);
    });

    $(document).on('keyup', '.titan-centre-space-row input[type="text"]:not(.readonly-field), .nontitan-centre-space-row input[type="text"]:not(.readonly-field)', function(){
        var statusCol = $(this).closest('tr').closest('tr').find('td[class*=_status]');
        statusCol.find('.spinner').hide();
        statusCol.find('.invalid-feedback').hide();
        statusCol.find('.btn').show();
    });

    $(document).on('change', '.titan-centre-space-row select, .nontitan-centre-space-row select', function() {
        var statusCol = $(this).closest('tr').closest('tr').find('td[class*=_status]');
        statusCol.find('.spinner').hide();
        statusCol.find('.invalid-feedback').hide();
        statusCol.find('.btn').show();
    });

    $(document).on('click', '.send_tree', function(ev){
        ev. preventDefault();
        var url = '/centre/hardware_review';
        customfn.getModal(url, $(this), {keyboard: false, backdrop: 'static'});
    });

    $(document).on('click', '.release-this-centre', async function(ev){
        ev. preventDefault();
        var url = $(this).data('href');

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});

        var $form = $(this).closest('form');

        $('#modal-wrapper .modal-body').html('<i class="fa fa-cog fa-spin fa-3x fa-fw margin-bottom"></i>');
        customfn.setButtonLoadingState($(this));
        $('#modal-wrapper .close-btn').hide();
        $(document).find('.release_centre_errors').remove();

        try {
            const response = await axios.post(url, $.param(formFields));
            const data = response.data;

            if(data.status && data.status == 1){
                // Keep loading active, and set timeout to check for release state
                // Wait for 5 seconds to give time to start job
                setTimeout(function(){
                    checkReleaseState(data.url, $form)
                }, 5000);
                // Show the next button
                // $('#modal-wrapper i.fa').removeClass('fa-spin');
                // $form.submit();
            }
        } catch (error) {
            let message = '';
            if (error.response && error.response.data) {
                const data = error.response.data;
                if (data.Message) {
                    message = '<br />' + data.Message;
                }
            }

            customfn.hideModals();
            $('.release_centre_check').before('<div class="row release_centre_errors"><div class="col-md-7"><div class="alert alert-info"><span class="fa fa-location-arrow"></span>Something went wrong while releasing the centre, please try again' + message + '</div></div></div>');
        }

        //var url = '/centre/hardware_activations';

    })



    $(document).on('click', 'a.release_centre_check', function(ev) {
        ev.preventDefault();
        // Check if the user can click ont this button

        //if ($(document).find('form#centre_hardware_activation').find('.device-status').length == $(document).find('form#centre_hardware_activation').find('.device-status').find('span.text-success').length){
            var url = $(this).attr('href');
            customfn.getModal(url, $(this), {keyboard: false, backdrop: 'static'});
        //}
        //else{
        //    $(this).closest('form').find('[data-loading-text]').button('toggle');
        //}
    });

    // Check if a id exists in the url
    // Trigger the click event of the add space
    if(window.location.hash &&
        window.location.hash == '#centre-centre-spaces-overview-add-space') {
        // Trigger the click
        $(document).find('#add_non_titan_row').click();
        //window.location.hash = 'centre-centre-spaces-overview';
    }
});

var checkReleaseStateXHR;
function checkReleaseState(url, $form) {

    if (typeof checkReleaseStateXHR !== "undefined") {
        checkReleaseStateXHR.abort();
    }
    $(document).find('.release_centre_errors').remove();
    checkReleaseStateXHR = $.ajax(url, {
        method: "GET",
        success : function(data){
            if(data.status && data.status == 1){
                // Show the next button
                $('#modal-wrapper i.fa').removeClass('fa-spin');
                $form.submit();
            }
        },
        error : function(jqXHR){
            var response = jqXHR.responseJSON;
            if(jqXHR.status == 404 || jqXHR.status == 422) {
                customfn.hideModals();
                var msg;
                if(response.message) {
                    msg = response.message;
                } else {
                    msg = 'Something went wrong while releasing the centre, please try again';
                }
                $('.release_centre_check').before('<div class="row release_centre_errors"><div class="col-md-7"><div class="alert alert-info"><span class="fa fa-location-arrow"></span>'+msg+'</div></div></div>');
            }
            else if(jqXHR.status == 503) {
                // Retry after 10 seconds
                setTimeout(function(){
                    checkReleaseState(url, $form)
                }, 10000);
            }
        }
    });
}
